// import { useState, useEffect } from "react";
// import {
//   LayoutGrid,
//   FileText,
//   Building,
//   ChevronRight,
//   ChevronLeft,
//   ChevronDown,
//   LogOut,
//   MapPin,
//   Phone,
//   HardHat,
//   Map,
//   CheckSquare,
//   Users,
//   Handshake,
//   Package,
//   DollarSign,
//   Settings,
//   Mail,
//   Pen,
//   Hammer,
//   Fuel,
//   Bolt,
//   Boxes,
//   BadgeDollarSign,
//   Scale,
//   UserPlus,
//   Gavel,
//   CalendarCheck,
// } from "lucide-react";
// import "../Sidebar/sidebar.css";
// import { NavLink, useNavigate, useLocation } from "react-router-dom";
// import { p, path } from "framer-motion/client";

// export default function Sidebar({ isOpen, setIsOpen }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [collapsed, setCollapsed] = useState(false);
//   const [activeSection, setActiveSection] = useState("Dashboard");
//   const [activeColor, setActiveColor] = useState("blue"); // track color key in state (e.g., 'blue')
//   const [favorites, setFavorites] = useState(["Dashboard", "Calendar"]);
//   const [expandedMenus, setExpandedMenus] = useState({});

//   // Extract user role and department from localStorage
//   const storedData = JSON.parse(
//     localStorage.getItem("NagpurProperties") || "{}"
//   );
//   const DepartMentName = storedData?.department?.departmentName;
//   const actualRole = Array.isArray(storedData?.role)
//     ? storedData.role[0]?.roleName
//     : storedData?.role;

//   const colorMap = {
//     blue: "#3b82f6",
//     purple: "#8b5cf6",
//     orange: "#f97316",
//     red: "#ef4444",
//     green: "#22c55e",
//     teal: "#14b8a6",
//     indigo: "#4B0082",
//     yellow: "#fbbf24",
//     emerald: "#059669",
//     gray: "#6b7280",
//     lime: "#84cc16",
//     pink: "#ec4899",
//     violet: "#a855f7",
//     cyan: "#06b6d4",
//     amber: "#d97706",
//     rose: "#f43f5e",
//     sky: "#0ea5e9",
//     brown: "#A52A2A", // Added for Stationary Management
//   };

//   useEffect(() => {
//     const saved = localStorage.getItem("NagpurProperties");
//     if (saved) {
//       try {
//         const data = JSON.parse(saved);
//         if (data.activeSection) setActiveSection(data.activeSection);
//         if (data.activeColorKey) setActiveColor(data.activeColorKey);
//       } catch (e) {
//         console.error("Error parsing NagpurProperties:", e);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     if (isOpen !== undefined && setIsOpen) {
//       if (window.innerWidth < 768) {
//         setCollapsed(!isOpen);
//       }
//     }
//   }, [isOpen, setIsOpen]);

//   const toggleCollapsed = () => {
//     const newCollapsedState = !collapsed;
//     setCollapsed(newCollapsedState);
//     if (setIsOpen) setIsOpen(!newCollapsedState);
//   };

//   const toggleSubmenu = (sectionName, e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setExpandedMenus((prev) => ({
//       ...prev,
//       [sectionName]: !prev[sectionName],
//     }));
//   };

//   const updateLocalStorageActiveSection = (sectionName, colorKey) => {
//     const saved = localStorage.getItem("NagpurProperties");
//     const data = saved ? JSON.parse(saved) : {};
//     data.activeSection = sectionName;
//     data.activeColorKey = colorKey;
//     data.activeColorHex = colorMap[colorKey] || "#3b82f6";
//     localStorage.setItem("NagpurProperties", JSON.stringify(data));
//     window.dispatchEvent(new Event("localStorageUpdated")); // Fixed event name case
//     setActiveSection(sectionName);
//     setActiveColor(colorKey);
//   };

//   const sections = [
//     // {
//     //   name: "Land Management",
//     //   icon: <Map size={22} />,
//     //   color: "blue",
//     //   colorHex: "#3b82f6",
//     //   path: "/land",
//     // },
//     // {
//     //   name: "Lead Management",
//     //   icon: <Phone size={22} />,
//     //   color: "purple",
//     //   colorHex: "#8b5cf6",
//     //   path: "/leadProject",
//     // },
//     // {
//     //   name: "Partner Management",
//     //   icon: <HardHat size={22} />,
//     //   color: "orange",
//     //   colorHex: "#f97316",
//     //   path: "/labour",
//     // },
//     // {
//     //   name: "Plot Management",
//     //   icon: <MapPin size={22} />,
//     //   color: "red",
//     //   colorHex: "#ef4444",
//     //   path: "/plot",
//     // },
//     // {
//     //   name: "Task Management",
//     //   icon: <CheckSquare size={22} />,
//     //   color: "green",
//     //   colorHex: "#22c55e",
//     //   hasSubmenu: true,
//     //   subItems: [
//     //     {
//     //       name: actualRole === "Employee" ? "View Task" : "Add Task",
//     //       icon: <Package size={18} />,
//     //       path: "/task",
//     //       color: "green",
//     //       colorHex: "#22c55e",
//     //     },
//     //     {
//     //       name: "Task Summary",
//     //       icon: <HardHat size={18} />,
//     //       path: "/taskSummary",
//     //       color: "green",
//     //       colorHex: "#22c55e",
//     //     },
//     //   ],
//     // },
//     {
//       name: "Material Management",
//       icon: <Users size={22} />,
//       color: "teal",
//       colorHex: "#14b8a6",
//       hasSubmenu: true,
//       subItems: [
//         {
//           name : "Worker Attendance",
//           icon: <Package size={18} />,
//           path: "/worker-attendance",
//           color: "teal",
//           colorHex: "#14b8a6",
//         },
//         {
//           name : "Worker Management",
//           icon: <Package size={18} />,
//           path: "/worker",
//           color: "teal",
//           colorHex: "#14b8a6",
//         },
//         // {
//         //   name: "daily Material",
//         //   icon: <Package size={18} />,
//         //   path: "venders",
//         //   color: "teal",
//         //   colorHex: "#14b8a6",
//         // },
//         {
//           name: "daily Material",
//           icon: <Package size={18} />,
//           path: "venders",
//           color: "teal",
//           colorHex: "#14b8a6",
//         },
//         // {
//         //   name: "Purchase Orders",
//         //   icon: <Hammer size={18} />,
//         //   path: "/purchesOrder",
//         //   color: "teal",
//         //   colorHex: "#14b8a6",
//         // },
//         // {
//         //   name: "Vehicle Entry",
//         //   icon: <Hammer size={18} />,
//         //   path: "/vehicleMaterial",
//         //   color: "teal",
//         //   colorHex: "#14b8a6",
//         // },
//         {
//           name: "Stock Transfer",
//           icon: <FileText size={18} />,
//           path: "/MaterialStock",
//           color: "teal",
//           colorHex: "#14b8a6",
//         },
//         {
//           name: "Stock Summary",
//           icon: <Hammer size={18} />,
//           path: "/StockSummary",
//           color: "teal",
//           colorHex: "#14b8a6",
//         },
//       ],
//     },

//      {
//       name: "Engineer Management",
//       icon: <Users size={22} />,
//       color: "indigo",
//       colorHex: "#185fa5",
//       hasSubmenu: true,
//       subItems: [
//         {
//           name: "Engineer",
//           icon: <Package size={18} />,
//           path: "/engineer",
//           color: "indigo",
//           colorHex: "#185fa5",
//         },
//         {
//           name: "Engineer Attendance ",
//           icon: <FileText size={18} />,
//           path: "/engineer-attendance",
//           color: "indigo",
//           colorHex: "#185fa5",
//         },
//          {
//           name: "Engineer Leave",
//           icon: <FileText size={18} />,
//           path: "/engineerLeave",
//           color: "indigo",
//           colorHex: "#185fa5",
//         },

//         {
//           name: "Engineer Payment",
//           icon: <Hammer size={18} />,
//           path: "/engineerPayment",
//           color: "indigo",
//           colorHex: "#185fa5",
//         },
//         // {
//         //   name: "Engineer Advance  Payment",
//         //   icon: <Hammer size={18} />,
//         //   path: "/engineer-payment",
//         //   color: "indigo",
//         //   colorHex: "#185fa5",
//         // },
//         // {
//         //   name: "Engineer Welfare",
//         //   icon: <Hammer size={18} />,
//         //   path: "/engineer-payment",
//         //   color: "indigo",
//         //   colorHex: "#185fa5",
//         // },
//       ],
//     },
//     // {
//     //   name: "Employee Management",
//     //   icon: <Users size={22} />,
//     //   color: "indigo",
//     //   colorHex: "#4B0082",
//     //   hasSubmenu: true,
//     //   subItems: [
//     //     {
//     //       name: "Add Department",
//     //       icon: <Package size={18} />,
//     //       path: "/getDepartment",
//     //       color: "indigo",
//     //       colorHex: "#4B0082",
//     //     },
//     //     {
//     //       name: "Attendance",
//     //       icon: <FileText size={18} />,
//     //       path: "/empList",
//     //       color: "indigo",
//     //       colorHex: "#4B0082",
//     //     },
//     //     {
//     //       name: "Add Holiday",
//     //       icon: <Hammer size={18} />,
//     //       path: "/holiday",
//     //       color: "indigo",
//     //       colorHex: "#4B0082",
//     //     },
//     //   ],
//     // },
//     // {
//     //   name: "Contractor Management",
//     //   icon: <Handshake size={22} />,
//     //   color: "yellow",
//     //   colorHex: "#fbbf24",
//     //   path: "/contractor",
//     // },
//     // {
//     //   name: "Finance Management",
//     //   icon: <DollarSign size={22} />,
//     //   color: "emerald",
//     //   colorHex: "#059669",
//     //   hasSubmenu: true,
//     //   subItems: [
//     //     {
//     //       name: "Bank Details",
//     //       icon: <Bolt size={18} />,
//     //       path: "/addBank",
//     //       color: "emerald",
//     //       colorHex: "#059669",
//     //     },
//     //     {
//     //       name: "Add Parties",
//     //       icon: <Boxes size={18} />,
//     //       path: "/party",
//     //       color: "emerald",
//     //       colorHex: "#059669",
//     //     },
//     //     {
//     //       name: "View Transaction",
//     //       icon: <BadgeDollarSign size={18} />,
//     //       path: "/Transaction",
//     //       color: "emerald",
//     //       colorHex: "#059669",
//     //     },
//     //   ],
//     // },
//     // {
//     //   name: "Advocates",
//     //   icon: <Scale size={22} />,
//     //   color: "slate",
//     //   colorHex: "#475569",
//     //   hasSubmenu: true,
//     //   subItems: [
//     //     {
//     //       name: "Add Advocates",
//     //       icon: <UserPlus size={18} />,
//     //       path: "/add-advocate",
//     //       color: "slate",
//     //       colorHex: "#475569",
//     //     },
//     //     {
//     //       name: "Advocates Assignment",
//     //       icon: <Gavel size={18} />,
//     //       path: "/advocates-assignment",
//     //       color: "slate",
//     //       colorHex: "#475569",
//     //     },
//     //     {
//     //       name: "Advocates Follow-up",
//     //       icon: <CalendarCheck size={18} />,
//     //       path: "/advocates-follow-up",
//     //       color: "slate",
//     //       colorHex: "#475569",
//     //     },
//     //   ],
//     // },
//     {
//       name: "Machine Management",
//       icon: <Settings size={22} />,
//       color: "gray",
//       colorHex: "#6b7280",
//       hasSubmenu: true,
//       subItems: [
//         {
//           name: "Add Machine",
//           icon: <Package size={18} />,
//           path: "/machine",
//           color: "gray",
//           colorHex: "#6b7280",
//         },
//         {
//           name: "Maintainance",
//           icon: <FileText size={18} />,
//           path: "/maintainance",
//           color: "gray",
//           colorHex: "#6b7280",
//         },
//         {
//           name: "Trip schedule",
//           icon: <Hammer size={18} />,
//           path: "/TripSchedule",
//           color: "gray",
//           colorHex: "#6b7280",
//         },
//         {
//           name: "Fuel Maintainance",
//           icon: <Fuel size={18} />,
//           path: "/fuel",
//           color: "gray",
//           colorHex: "#6b7280",
//         },
//       ],
//     },
//     // {
//     //   name: "Letter Head",
//     //   icon: <Mail size={22} />,
//     //   color: "lime",
//     //   colorHex: "#84cc16",
//     //   path: "/letter",
//     // },
//     // {
//     //   name: "Office Expense",
//     //   icon: <Building size={22} />,
//     //   color: "pink",
//     //   colorHex: "#ec4899",
//     //   path: "/office",
//     // },
//     // {
//     //   name: "Stationary Management",
//     //   icon: <Pen size={22} />,
//     //   color: "brown",
//     //   colorHex: "#A52A2A",
//     //   path: "/stationary",
//     // },
//     // {
//     //   name: "Registration",
//     //   icon: <FileText size={22} />,
//     //   color: "cyan",
//     //   colorHex: "#06b6d4",
//     //   path: "/registration",
//     // },
//   ];

//   const mainNavItems = [
//     {
//       name: "Dashboard",
//       icon: <LayoutGrid size={20} />,
//       path: "/",
//       color: "blue",
//       colorHex: "#3b82f6",
//     },
//   ];
//   const bottomNavItems = [{ name: "Logout", icon: <LogOut size={20} /> }];

//   const handleSectionClick = (section) => {
//     if (section.hasSubmenu && !collapsed) {
//       toggleSubmenu(section.name, {
//         preventDefault: () => {},
//         stopPropagation: () => {},
//       });
//     } else {
//       updateLocalStorageActiveSection(section.name, section.color);
//       if (section.path) navigate(section.path);
//       if (setIsOpen) setIsOpen(false);
//     }
//   };

//   const handleSubItemClick = (subItem, parentSection) => {
//     const colorToUse = subItem.color || parentSection.color || "blue";
//     updateLocalStorageActiveSection(subItem.name, colorToUse);
//     if (subItem.path) navigate(subItem.path);
//     if (setIsOpen) setIsOpen(false);
//     if (!expandedMenus[parentSection.name]) {
//       setExpandedMenus((prev) => ({ ...prev, [parentSection.name]: true }));
//     }
//   };

//   const handleDashboardClick = (item) => {
//     updateLocalStorageActiveSection(item.name, item.color);
//     if (setIsOpen) setIsOpen(false);
//   };

//   const handleLogOut = () => {
//     if (window.confirm("Are You Sure To LogOut ?")) {
//       localStorage.removeItem("NagpurProperties");
//       navigate("/login");
//     }
//   };

//   const fallbackColorFromUrl = () => {
//     const match = sections.find(
//       (sec) =>
//         location.pathname.startsWith(sec.path) ||
//         sec.subItems?.some((sub) => location.pathname.startsWith(sub.path))
//     );
//     return match?.color || "blue";
//   };
//   const headerColorClass = activeColor || fallbackColorFromUrl();

//   const getActiveStyle = (colorHex) => ({
//     backgroundColor: colorHex,
//     borderLeftColor: colorHex,
//     color: "white",
//   });

//   useEffect(() => {
//     const parentMatch = sections.find((sec) =>
//       sec.subItems?.some((sub) => location.pathname.startsWith(sub.path))
//     );
//     if (parentMatch) {
//       setExpandedMenus((prev) => ({ ...prev, [parentMatch.name]: true }));
//       const subMatch = parentMatch.subItems.find((sub) =>
//         location.pathname.startsWith(sub.path)
//       );
//       if (subMatch) {
//         updateLocalStorageActiveSection(
//           subMatch.name,
//           subMatch.color || parentMatch.color
//         );
//       }
//     }
//   }, [location.pathname]);

//   return (
//     <aside
//       className={`sidebar-main ${collapsed ? "sidebar-collapsed" : ""} ${
//         isOpen ? "sidebar-open" : ""
//       }`}
//     >
//       {/* Header */}
//       <div
//         className={`sidebar-header ${
//           headerColorClass ? `header-active ${headerColorClass}` : ""
//         }`}
//       >
//         <div className="sidebar-logo">
//           <div className="sidebar-logo-icon">SS</div>
//           {!collapsed && <span className="sidebar-logo-text">Group</span>}
//         </div>
//         <button className="sidebar-collapse-button" onClick={toggleCollapsed}>
//           {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
//         </button>
//       </div>

//       <nav className="sidebar-nav">
//         {/* Favorites */}
//         {favorites.length > 0 && (
//           <div className="sidebar-nav-section">
//             <span className="sidebar-nav-section-title">Favorites</span>
//             <ul className="sidebar-nav-items">
//               {mainNavItems
//                 .filter((item) => favorites.includes(item.name))
//                 .map((item) => (
//                   <li key={`fav-${item.name}`}>
//                     <NavLink
//                       to={item.path}
//                       end
//                       className={({ isActive }) =>
//                         `sidebar-nav-item ${
//                           isActive ? "sidebar-active" : ""
//                         } dashboard-item`
//                       }
//                       style={({ isActive }) =>
//                         isActive
//                           ? {
//                               backgroundColor: "rgba(59, 130, 246, 0.1)",
//                               borderLeftColor: "#3b82f6",
//                             }
//                           : {}
//                       }
//                       onClick={() => handleDashboardClick(item)}
//                     >
//                       <span className="sidebar-nav-icon dashboard-icon">
//                         {item.icon}
//                       </span>
//                       {!collapsed && (
//                         <span className="sidebar-nav-text dashboard-text">
//                           {item.name}
//                         </span>
//                       )}
//                     </NavLink>
//                   </li>
//                 ))}
//             </ul>
//           </div>
//         )}

//         {/* Modules */}
//         <div className="sidebar-nav-section">
//           <span className="sidebar-nav-section-title">Modules</span>
//           <ul className="sidebar-nav-items">
//             {sections
//               .filter((section) => {
//                 if (actualRole === "Head" && DepartMentName === "Sales") {
//                   return ["Lead Management", "Task Management", "Advocates"].includes(
//                     section.name
//                   );
//                 }
//                 if (actualRole === "Admin" || actualRole === "Head"||actualRole === "SuperAdmin")
//                   return true;
//                 if (actualRole === "Partner")
//                   return section.name === "Land Management";
//                 if (DepartMentName === "Finance" && actualRole === "Employee") {
//                   return ["Task Management", "Finance Management"].includes(
//                     section.name
//                   );
//                 }
//                 if (actualRole === "Employee") {
//                   return ["Task Management", "Lead Management", "Advocates"].includes(
//                     section.name
//                   ); 
//                 }
//                 if (actualRole === "Engineer")
//                 return section.name === "Material Management","Engineer Management";
//                 if (actualRole === "SuperEngineer")
//                   // return section.name === "Material Management", "Machine Management";
//                 return ["Material Management", "Engineer Management", "Machine Management"].includes(section.name);
                
//                 return false;
//               })
//               .map((section) => {
//                 const hasActiveSub =
//                   section.hasSubmenu &&
//                   section.subItems?.some((sub) =>
//                     location.pathname.startsWith(sub.path)
//                   );

//                 const parentExactActive = location.pathname === section.path;
//                 return (
//                   <li key={section.name}>
//                     <NavLink
//                       to={section.path || "#"}
//                       end
//                       className={({ isActive }) =>
//                         `sidebar-nav-item ${
//                           isActive && parentExactActive && !hasActiveSub
//                             ? "sidebar-active"
//                             : ""
//                         } ${
//                           section.hasSubmenu && !collapsed ? "has-submenu" : ""
//                         } ${section.color}`
//                       }
//                       style={({ isActive }) =>
//                         isActive && parentExactActive && !hasActiveSub
//                           ? getActiveStyle(section.colorHex)
//                           : {}
//                       }
//                       onClick={(e) => {
//                         if (section.hasSubmenu && !collapsed) {
//                           toggleSubmenu(section.name, e);
//                         } else {
//                           handleSectionClick(section);
//                         }
//                       }}
//                     >
//                       <span
//                         className={`sidebar-nav-icon sidebar-module-icon ${section.color}`}
//                       >
//                         {section.icon}
//                       </span>
//                       {!collapsed && (
//                         <>
//                           <span className="sidebar-nav-text">
//                             {section.name}
//                           </span>

//                           {section.hasSubmenu && (
//                             <span
//                               className={`sidebar-submenu-arrow ${
//                                 expandedMenus[section.name]
//                                   ? "sidebar-expanded"
//                                   : ""
//                               }`}
//                               onClick={(e) => toggleSubmenu(section.name, e)}
//                             >
//                               <ChevronDown size={16} />
//                             </span>
//                           )}
//                         </>
//                       )}
//                     </NavLink>

//                     {/* Submenu */}
//                     {section.hasSubmenu &&
//                       expandedMenus[section.name] &&
//                       !collapsed && (
//                         <ul className="sidebar-submenu">
//                           {section.subItems
//                             .filter((subItem) => {
//                               if (
//                                 actualRole === "Employee" &&
//                                 subItem.name === "Task Summary"
//                               )
//                                 return false;
//                               return true;
//                             })
//                             .map((subItem) => (
//                               <li key={subItem.name}>
//                                 <NavLink
//                                   to={subItem.path}
//                                   end
//                                   className={({ isActive }) =>
//                                     `sidebar-nav-item sidebar-submenu-item ${
//                                       isActive ? "sidebar-active" : ""
//                                     } ${subItem.color}`
//                                   }
//                                   style={({ isActive }) =>
//                                     isActive
//                                       ? getActiveStyle(subItem.colorHex)
//                                       : {}
//                                   }
//                                   onClick={() =>
//                                     handleSubItemClick(subItem, section)
//                                   }
//                                 >
//                                   <span className="sidebar-nav-icon sidebar-submenu-icon">
//                                     {subItem.icon}
//                                   </span>
//                                   <span className="sidebar-nav-text">
//                                     {subItem.name}
//                                   </span>
//                                 </NavLink>
//                               </li>
//                             ))}
//                         </ul>
//                       )}
//                   </li>
//                 );
//               })}
//           </ul>
//         </div>
//       </nav>

//       {/* Footer – Logout */}
//       <div className="sidebar-footer">
//         <ul className="sidebar-nav-items">
//           {bottomNavItems.map((item) => (
//             <li key={item.name}>
//               <a
//                 href="#"
//                 className="sidebar-nav-item"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleLogOut();
//                 }}
//               >
//                 <span className="sidebar-nav-icon">{item.icon}</span>
//                 {!collapsed && (
//                   <span className="sidebar-nav-text">{item.name}</span>
//                 )}
//               </a>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </aside>
//   );
// }





import { useState, useEffect } from "react";
import {
  LayoutGrid,
  FileText,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  LogOut,
  Users,
  Package,
  Hammer,
  Fuel,
  Settings,
} from "lucide-react";
import "../Sidebar/sidebar.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

export default function Sidebar({ isOpen, setIsOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [activeSection, setActiveSection] = useState("Dashboard");
  const [activeColor, setActiveColor] = useState("blue"); // track color key in state (e.g., 'blue')
  const [favorites, setFavorites] = useState(["Dashboard", "Calendar"]);

  // Submenus are expanded by default
  const [expandedMenus, setExpandedMenus] = useState({
    "Material Management": true,
    "Engineer Management": true,
    "Machine Management": true,
  });

  // Extract user role and department from localStorage
  const storedData = JSON.parse(
    localStorage.getItem("NagpurProperties") || "{}"
  );
  const DepartMentName = storedData?.department?.departmentName;
  const actualRole = Array.isArray(storedData?.role)
    ? storedData.role[0]?.roleName
    : storedData?.role;

  const colorMap = {
    blue: "#3b82f6",
    teal: "#14b8a6",
    indigo: "#185fa5",
    gray: "#6b7280",
  };

  useEffect(() => {
    const saved = localStorage.getItem("NagpurProperties");
    if (saved) {
      try {
        const data = JSON.parse(saved);
        if (data.activeSection) setActiveSection(data.activeSection);
        if (data.activeColorKey) setActiveColor(data.activeColorKey);
      } catch (e) {
        console.error("Error parsing NagpurProperties:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (isOpen !== undefined && setIsOpen) {
      if (window.innerWidth < 768) {
        setCollapsed(!isOpen);
      }
    }
  }, [isOpen, setIsOpen]);

  const toggleCollapsed = () => {
    const newCollapsedState = !collapsed;
    setCollapsed(newCollapsedState);
    if (setIsOpen) setIsOpen(!newCollapsedState);
  };

  const toggleSubmenu = (sectionName, e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpandedMenus((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };

  const updateLocalStorageActiveSection = (sectionName, colorKey) => {
    const saved = localStorage.getItem("NagpurProperties");
    const data = saved ? JSON.parse(saved) : {};
    data.activeSection = sectionName;
    data.activeColorKey = colorKey;
    data.activeColorHex = colorMap[colorKey] || "#3b82f6";
    localStorage.setItem("NagpurProperties", JSON.stringify(data));
    window.dispatchEvent(new Event("localStorageUpdated"));
    setActiveSection(sectionName);
    setActiveColor(colorKey);
  };

  const sections = [
    {
      name: "Material Management",
      icon: <Users size={22} />,
      color: "teal",
      colorHex: "#14b8a6",
      hasSubmenu: true,
      subItems: [
        {
          name: "Worker Attendance",
          icon: <Package size={18} />,
          path: "/worker-attendance",
          color: "teal",
          colorHex: "#14b8a6",
        },
        {
          name: "Worker Management",
          icon: <Package size={18} />,
          path: "/worker",
          color: "teal",
          colorHex: "#14b8a6",
        },
        {
          name: "daily Material",
          icon: <Package size={18} />,
          path: "venders",
          color: "teal",
          colorHex: "#14b8a6",
        },
        {
          name: "Stock Transfer",
          icon: <FileText size={18} />,
          path: "/MaterialStock",
          color: "teal",
          colorHex: "#14b8a6",
        },
        {
          name: "Stock Summary",
          icon: <Hammer size={18} />,
          path: "/StockSummary",
          color: "teal",
          colorHex: "#14b8a6",
        },
      ],
    },
    {
      name: "Engineer Management",
      icon: <Users size={22} />,
      color: "indigo",
      colorHex: "#185fa5",
      hasSubmenu: true,
      subItems: [
        {
          name: "Engineer",
          icon: <Package size={18} />,
          path: "/engineer",
          color: "indigo",
          colorHex: "#185fa5",
        },
        {
          name: "Engineer Attendance",
          icon: <FileText size={18} />,
          path: "/engineer-attendance",
          color: "indigo",
          colorHex: "#185fa5",
        },
        {
          name: "Engineer Leave",
          icon: <FileText size={18} />,
          path: "/engineerLeave",
          color: "indigo",
          colorHex: "#185fa5",
        },
        {
          name: "Engineer Payment",
          icon: <Hammer size={18} />,
          path: "/engineerPayment",
          color: "indigo",
          colorHex: "#185fa5",
        },
      ],
    },
    {
      name: "Machine Management",
      icon: <Settings size={22} />,
      color: "gray",
      colorHex: "#6b7280",
      hasSubmenu: true,
      subItems: [
        {
          name: "Add Machine",
          icon: <Package size={18} />,
          path: "/machine",
          color: "gray",
          colorHex: "#6b7280",
        },
        // {
        //   name: "Maintainance",
        //   icon: <FileText size={18} />,
        //   path: "/maintainance",
        //   color: "gray",
        //   colorHex: "#6b7280",
        // },
        // {
        //   name: "Trip schedule",
        //   icon: <Hammer size={18} />,
        //   path: "/TripSchedule",
        //   color: "gray",
        //   colorHex: "#6b7280",
        // },
        // {
        //   name: "Fuel Maintainance",
        //   icon: <Fuel size={18} />,
        //   path: "/fuel",
        //   color: "gray",
        //   colorHex: "#6b7280",
        // },
      ],
    },
  ];

  const mainNavItems = [
    {
      name: "Dashboard",
      icon: <LayoutGrid size={20} />,
      path: "/",
      color: "blue",
      colorHex: "#3b82f6",
    },
  ];
  const bottomNavItems = [{ name: "Logout", icon: <LogOut size={20} /> }];

  const handleSectionClick = (section) => {
    if (section.hasSubmenu && !collapsed) {
      toggleSubmenu(section.name, {
        preventDefault: () => {},
        stopPropagation: () => {},
      });
    } else {
      updateLocalStorageActiveSection(section.name, section.color);
      if (section.path) navigate(section.path);
      if (setIsOpen) setIsOpen(false);
    }
  };

  const handleSubItemClick = (subItem, parentSection) => {
    const colorToUse = subItem.color || parentSection.color || "blue";
    updateLocalStorageActiveSection(subItem.name, colorToUse);
    if (subItem.path) navigate(subItem.path);
    if (setIsOpen) setIsOpen(false);
    if (!expandedMenus[parentSection.name]) {
      setExpandedMenus((prev) => ({ ...prev, [parentSection.name]: true }));
    }
  };

  const handleDashboardClick = (item) => {
    updateLocalStorageActiveSection(item.name, item.color);
    if (setIsOpen) setIsOpen(false);
  };

  const handleLogOut = () => {
    if (window.confirm("Are You Sure To LogOut ?")) {
      localStorage.removeItem("NagpurProperties");
      navigate("/login");
    }
  };

  const fallbackColorFromUrl = () => {
    const match = sections.find(
      (sec) =>
        (sec.path && location.pathname.startsWith(sec.path)) ||
        sec.subItems?.some((sub) => location.pathname.startsWith(sub.path))
    );
    return match?.color || "blue";
  };
  const headerColorClass = activeColor || fallbackColorFromUrl();

  const getActiveStyle = (colorHex) => ({
    backgroundColor: colorHex,
    borderLeftColor: colorHex,
    color: "white",
  });

  useEffect(() => {
    const parentMatch = sections.find((sec) =>
      sec.subItems?.some((sub) => location.pathname.startsWith(sub.path))
    );
    if (parentMatch) {
      setExpandedMenus((prev) => ({ ...prev, [parentMatch.name]: true }));
      const subMatch = parentMatch.subItems.find((sub) =>
        location.pathname.startsWith(sub.path)
      );
      if (subMatch) {
        updateLocalStorageActiveSection(
          subMatch.name,
          subMatch.color || parentMatch.color
        );
      }
    }
  }, [location.pathname]);

  return (
    <aside
      className={`sidebar-main ${collapsed ? "sidebar-collapsed" : ""} ${
        isOpen ? "sidebar-open" : ""
      }`}
    >
      {/* Header */}
      <div
        className={`sidebar-header ${
          headerColorClass ? `header-active ${headerColorClass}` : ""
        }`}
      >
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">SS</div>
          {!collapsed && <span className="sidebar-logo-text">Group</span>}
        </div>
        <button className="sidebar-collapse-button" onClick={toggleCollapsed}>
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>

      <nav className="sidebar-nav">
        {/* Favorites */}
        {favorites.length > 0 && (
          <div className="sidebar-nav-section">
            <span className="sidebar-nav-section-title">Favorites</span>
            <ul className="sidebar-nav-items">
              {mainNavItems
                .filter((item) => favorites.includes(item.name))
                .map((item) => (
                  <li key={`fav-${item.name}`}>
                    <NavLink
                      to={item.path}
                      end
                      className={({ isActive }) =>
                        `sidebar-nav-item ${
                          isActive ? "sidebar-active" : ""
                        } dashboard-item`
                      }
                      style={({ isActive }) =>
                        isActive
                          ? {
                              backgroundColor: "rgba(59, 130, 246, 0.1)",
                              borderLeftColor: "#3b82f6",
                            }
                          : {}
                      }
                      onClick={() => handleDashboardClick(item)}
                    >
                      <span className="sidebar-nav-icon dashboard-icon">
                        {item.icon}
                      </span>
                      {!collapsed && (
                        <span className="sidebar-nav-text dashboard-text">
                          {item.name}
                        </span>
                      )}
                    </NavLink>
                  </li>
                ))}
            </ul>
          </div>
        )}

        {/* Modules */}
        <div className="sidebar-nav-section">
          <span className="sidebar-nav-section-title">Modules</span>
          <ul className="sidebar-nav-items">
            {sections
              .filter((section) => {
                if (
                  actualRole === "Admin" ||
                  actualRole === "Head" ||
                  actualRole === "SuperAdmin"
                )
                  return true;
                if (actualRole === "Engineer")
                  return ["Material Management", "Engineer Management"].includes(
                    section.name
                  );
                if (actualRole === "SuperEngineer")
                  return [
                    "Material Management",
                    "Engineer Management",
                    "Machine Management",
                  ].includes(section.name);
                return false;
              })
              .map((section) => {
                const hasActiveSub =
                  section.hasSubmenu &&
                  section.subItems?.some((sub) =>
                    location.pathname.startsWith(sub.path)
                  );

                const parentExactActive = location.pathname === section.path;
                return (
                  <li key={section.name}>
                    <NavLink
                      to={section.path || "#"}
                      end
                      className={({ isActive }) =>
                        `sidebar-nav-item ${
                          isActive && parentExactActive && !hasActiveSub
                            ? "sidebar-active"
                            : ""
                        } ${
                          section.hasSubmenu && !collapsed ? "has-submenu" : ""
                        } ${section.color}`
                      }
                      style={({ isActive }) =>
                        isActive && parentExactActive && !hasActiveSub
                          ? getActiveStyle(section.colorHex)
                          : {}
                      }
                      onClick={(e) => {
                        if (section.hasSubmenu && !collapsed) {
                          toggleSubmenu(section.name, e);
                        } else {
                          handleSectionClick(section);
                        }
                      }}
                    >
                      <span
                        className={`sidebar-nav-icon sidebar-module-icon ${section.color}`}
                      >
                        {section.icon}
                      </span>
                      {!collapsed && (
                        <>
                          <span className="sidebar-nav-text">
                            {section.name}
                          </span>

                          {section.hasSubmenu && (
                            <span
                              className={`sidebar-submenu-arrow ${
                                expandedMenus[section.name]
                                  ? "sidebar-expanded"
                                  : ""
                              }`}
                              onClick={(e) => toggleSubmenu(section.name, e)}
                            >
                              <ChevronDown size={16} />
                            </span>
                          )}
                        </>
                      )}
                    </NavLink>

                    {/* Submenu */}
                    {section.hasSubmenu &&
                      expandedMenus[section.name] &&
                      !collapsed && (
                        <ul className="sidebar-submenu">
                          {section.subItems.map((subItem) => (
                            <li key={subItem.name}>
                              <NavLink
                                to={subItem.path}
                                end
                                className={({ isActive }) =>
                                  `sidebar-nav-item sidebar-submenu-item ${
                                    isActive ? "sidebar-active" : ""
                                  } ${subItem.color}`
                                }
                                style={({ isActive }) =>
                                  isActive
                                    ? getActiveStyle(subItem.colorHex)
                                    : {}
                                }
                                onClick={() =>
                                  handleSubItemClick(subItem, section)
                                }
                              >
                                <span className="sidebar-nav-icon sidebar-submenu-icon">
                                  {subItem.icon}
                                </span>
                                <span className="sidebar-nav-text">
                                  {subItem.name}
                                </span>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                  </li>
                );
              })}
          </ul>
        </div>
      </nav>

      {/* Footer – Logout */}
      <div className="sidebar-footer">
        <ul className="sidebar-nav-items">
          {bottomNavItems.map((item) => (
            <li key={item.name}>
              <a
                href="#"
                className="sidebar-nav-item"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogOut();
                }}
              >
                <span className="sidebar-nav-icon">{item.icon}</span>
                {!collapsed && (
                  <span className="sidebar-nav-text">{item.name}</span>
                )}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}